import { render, staticRenderFns } from "./UserDashboardItem.vue?vue&type=template&id=4eec0f92&"
import script from "./UserDashboardItem.vue?vue&type=script&lang=js&"
export * from "./UserDashboardItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eec0f92')) {
      api.createRecord('4eec0f92', component.options)
    } else {
      api.reload('4eec0f92', component.options)
    }
    module.hot.accept("./UserDashboardItem.vue?vue&type=template&id=4eec0f92&", function () {
      api.rerender('4eec0f92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/resources/UserDashboardItem.vue"
export default component.exports